export default __webpack_public_path__ + "static/media/reports.a84cf768.svg";